import { Box } from '@/shared/ui';
import {
  IMenuButtonProps,
  SettingMenuButton,
} from '@/shared/ui/SettingMenuButton';

export interface ITableSettingsMenuByIdProps extends IMenuButtonProps {}

export const TableSettingsMenuById = ({
  menuItems,
  ...otherProps
}: ITableSettingsMenuByIdProps) => {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <SettingMenuButton menuItems={menuItems} {...otherProps} />
    </Box>
  );
};
